export const common = {
  companyName: '小松ばね工業株式会社',
  companyNameEn: 'Komatsu Spring Industrial Co., Ltd.',
  slogan: 'きめ細かな発想',
  heroTagline: '品質で選ばれる、ばねの専門家',
  heroSubtitle: '精密ばねの受注生産を通じて、お客様のニーズに応えます',
  productInfo: '製品紹介',
  companyProfile: '会社紹介',
  blog: 'ブログ',
  contact: 'お問い合わせ',
  recruit: '採用情報',
  news: '最新情報',
  newsAll: '新着情報一覧へ',
  torsionSpring: 'トーションスプリング',
  compressionSpring: 'コイルスプリング(圧縮)',
  tensionSpring: 'コイルスプリング(引張)',
  wireForming: 'ワイヤーフォーミング加工',
  torsionSpringEn: 'TORSION SPRING',
  compressionSpringEn: 'COMPRESSION SPRING',
  tensionSpringEn: 'TENSION SPRING',
  wireFormingEn: 'WIRE FORMINGS',
  address: '〒143-0013 東京都大田区大森南5丁目3番18号',
  tel: '電話: 03-3743-0231(代表)',
  fax: 'FAX: 03-3743-0235',
  copyright: '© Komatsu Spring Industrial Co., Ltd.',
  features: '当社の特徴',
  springTypes: 'ばねの種類',
  products: '製品',
  usage: '用途',
  message: '社長メッセージ',
  companySummary: '会社概要',
  equipment: '設備',
  office: '事業所',
  history: '沿革',
  quality: '品質方針/環境方針',
  esg: 'ESG',
  registrations: '登録・会員団体',
  japanese: '日本語',
  english: 'English',
  chinese: '中文(简体)',
  chineseTraditional: '中文(繁體)',
  
  // Footer translations
  companyAddress: '〒143-0013 東京都大田区大森南5丁目3番18号',
  quickLinks: 'クイックリンク',
  home: 'ホーム',
  featuresTitle: '当社の特徴',
  businessHours: '営業時間',
  businessHoursDetail: '月曜日～金曜日 8:30-17:30（土日祝日休み）',
  // Features page content
  featuresSubtitle: '高品質を誇る私たちのスプリングは、繊細な発想と徹底したお客様第一主義のもとに生まれます。',
  delicateDesign: '繊細な発想',
  delicateDesignDesc: '「小さなスプリング一個といえども、精密製品の心臓部を形成する大切な部品の一つ」という発想のもとに技術開発に取り組んでいます。',
  prototypeToMass: '試作から量産まで',
  prototypeToMassDesc1: '試作1個から承ります。',
  prototypeToMassDesc2: '試作から機械にセットし製造するので量産時も同品質を確保します。',
  qualityControl: '徹底した品質管理',
  qualityControlDesc1: '品質は工場でつくりこむ:',
  qualityControlDesc1Detail: '製品の受注から製造を経て、納品にいたるまでの各工程で、徹底した管理・チェック体制を敷くことで、より万全な製品づくりを可能にしています。',
  qualityControlDesc2: '品質保証:',
  qualityControlDesc2Detail: '製品の納品時に確かな品質を約束する「製品検査成績表」を提供します。',
  qualityControlDesc3: '納期管理:',
  qualityControlDesc3Detail: 'コンピュータを駆使した徹底した納期管理します。',
  qualityControlDesc4: '品質維持:',
  qualityControlDesc4Detail: '自社にて冶工具類、金型の製作をするため高精度の品質維持ができます。',
  // Products page content
  productsTitle: 'ばねの種類・製品・用途',
  productsSubtitle: '1000種のニーズに、1000個の技術で',
  detailInfo: '詳細情報・動画は以下のリンクからご覧いただけます。',
  torsionSpringDetail: 'トーションばね',
  compressionSpringDetail: 'コイルばね(圧縮)',
  tensionSpringDetail: 'コイルばね(引張)',
  wireFormingDetail: 'ワイヤフォーミング加工',
  microSpring: '微細ばね・医療用特殊ばね',
  otherProducts: 'その他・工業製品以外',
  torsionSpringDesc: 'トーションばねは、コイルの中心軸のまわりに、ねじり荷重(トルク)を受けるばねです。',
  torsionSpringSpec: '製造実績:線径0.03㎜〜2.0㎜前後 丸線',
  compressionSpringDesc: '一般に押しばねといわれるこの種のばねは、圧縮荷重(コイル軸荷重)とたわみが比例します。',
  compressionSpringSpec1: '製造実績:線径0.02㎜〜2.0㎜ 丸線、平線',
  compressionSpringSpec2: '形状実績:長巻コイル、円錐、たる型、不等ピッチ、不等外径',
  tensionSpringDesc: '引張りコイルばねは本質的には、圧縮ばねと同一と考えられます。(コイル部は密着巻が一般的です)',
  tensionSpringSpec: '製造実績:線径0.08㎜〜2.0㎜前後',
  wireFormingDesc: 'フォーミングマシン等を使い様々に成型加工する「線細工ばね」',
  wireFormingSpec1: '製造実績:線径0.1㎜〜2㎜前後',
  wireFormingSpec2: '材料形状:丸線、平線',
  materials: '材料',
  materialTypes: 'ピアノ線、ステンレス線、プラチナ線、りん青銅線、各種メッキ線、その他',
  materialShapes: '丸線、平線',
  builtInProducts: '組込製品事例',
  builtInProductsSubtitle: '様々な製品に使われています',
  electricalProducts: '電気製品',
  electricalProductsList: '工業製品、家電、カメラ、プリンタ、ガス機器、火災報知器、電気メータ、その他',
  communication: '通信',
  communicationList: '携帯電話、充電台、端子台、時計、その他',
  medicalEquipment: '医療機器',
  medicalEquipmentList: 'カテーテル治療器、内視鏡装置、電気メス、生検用機器、健康器具、パルスオキシメータ、血圧計、体重計、万歩計、理容機器、その他',
  vehicleEquipment: '車両機器',
  vehicleEquipmentList: '自動車、オートバイ、草刈機、バス、その他',
  otherUsage: 'その他',
  otherUsageList: '宝飾品、錠前、音響機器、釣り具、文房具、玩具、家具、その他',
  usageTitle: '用途',
  usageSubtitle: '一つひとつの用途に合せた技術で対応',
  electricalUsage: 'スイッチ、コネクタ、電池通電用、通電部品、コンタクトプローブ、プリンタドットピン、センサ、その他',
  communicationUsage: '時計リューズ、時計日めくり、ヒンジ、アンテナ、カメラシャッタ、カメラレンズ周り、その他',
  medicalUsage: 'ガイドワイヤ用、内視鏡挿入部用、投影用マーカ、クリップ、生検機用、その他',
  vehicleUsage: 'キャブレタ、車内電装部品用、ブレーキスイッチ、その他',
  otherDetailUsage: 'フィルタ、留め具、ピアス、レコード針アーム支え、疑似餌フレーム、リール、文具用クリップ、ボールペン部品、その他',
  
  // Product detail pages common
  banner: '全て受注生産による精密機器のミクロサイエンス',
  clickToEnlarge: 'クリックすると拡大表示されます',
  manufacturingRecord: '製造実績',
  characteristics: '特徴',
  mainApplications: '主な用途',
  technicalSpecs: '技術仕様',
  qualityAssurance: '品質保証',
  contactUs: 'お問い合わせ',
  
  // Torsion Spring page - 追加
  torsionSpringApp1: '自動車のドアヒンジ',
  torsionSpringApp2: '洗濯機の蓋開閉機構',
  torsionSpringApp3: '電子機器のカバー開閉',
  torsionSpringApp4: '時計の巻き上げ機構',
  torsionSpringApp5: '玩具の駆動部品',
  
  // Compression Spring page - 追加
  compressionSpringFeature: '圧縮ばねは最も一般的なばねの一つで、軸方向の圧縮荷重を受けて縮む性質を持ちます。荷重とたわみが比例関係にあり、様々な機械部品や電子機器に使用されています。',
  compressionSpringApp1: '自動車のサスペンション',
  compressionSpringApp2: 'ボールペンの内部機構',
  compressionSpringApp3: '電子機器のスイッチ',
  compressionSpringApp4: '医療機器の部品',
  compressionSpringApp5: '工業機械の緩衝材',
  hardWire: '硬鋼線（SWC）',
  flatWire: '平線材料',
  specialShapes: '特殊形状対応',
  conicalSpring: '円錐ばね（テーパーコイル）',
  barrelSpring: 'たる型ばね（バレル型）',
  unevenPitch: '不等ピッチばね',
  unevenDiameter: '不等外径ばね',
  longCoil: '長巻きコイル',
  squareWireSpring: '角線ばね',
  precisionMeasurement: '精密測定',
  precisionMeasurementDesc: 'マイクロメーター級の精密測定機器を使用',
  loadTest: '荷重試験',
  loadTestDesc: '全ロットでばね荷重試験を実施',
  qualityCertificate: '品質保証書',
  qualityCertificateDesc: '検査データ付きの品質保証書を発行',
  
  // Tension Spring page
  tensionSpringFeature: '引張ばねは軸方向の引張荷重を受けて伸びる性質を持ちます。コイル部は密着巻きが一般的で、両端にはフック形状の加工を施します。圧縮ばねとは逆方向の力を利用する用途に適用されます。',
  tensionSpringApp1: '計測器のメーター針復帰機構',
  tensionSpringApp2: 'ドアクローザー',
  tensionSpringApp3: '電子部品の接続機構',
  tensionSpringApp4: '医療機器の操作部品',
  tensionSpringApp5: '自動車のケーブル類',
  hookTypes: 'フック形状の種類',
  roundHook: '丸フック',
  roundHookDesc: '最も一般的な円形のフック形状',
  angleHook: '角フック',
  angleHookDesc: '角度調整が可能な形状',
  specialHook: '特殊フック',
  specialHookDesc: '用途に応じたカスタム形状',
  materialsList: '材料',
  pianoWire: 'ピアノ線（SWP-A, SWP-B）',
  stainlessWire: 'ステンレス鋼線（SUS304, SUS316）',
  phosphorBronze: 'りん青銅線',
  berylliumCopper: 'ベリリウム銅線',
  specialAlloy: 'その他特殊合金線',
  processingRange: '加工範囲',
  wireDiameter: '線径',
  outerDiameter: '外径',
  freeLength: '自由長',
  effectiveCoils: '有効巻数：応相談',
  hookAccuracy: 'フック精度',
  hookAccuracyDesc: 'フック形状の寸法精度を厳格に管理',
  tensileTest: '引張試験',
  tensileTestDesc: '規定荷重での引張試験を全数実施',
  durabilityTest: '耐久性試験',
  durabilityTestDesc: '繰り返し荷重による耐久性を確認',
  
  // Wire Forming page
  wireFormingFeature: 'ワイヤフォーミング加工は、線材を様々な形状に成型する技術です。フォーミングマシンを使用して、複雑な3次元形状の部品を高精度で製造します。「線細工ばね」とも呼ばれ、多様な用途に対応可能です。',
  wireFormingApp1: 'クリップ、ステープル類',
  wireFormingApp2: '電子部品の接続端子',
  wireFormingApp3: '医療機器の細部品',
  wireFormingApp4: '時計・精密機器の部品',
  wireFormingApp5: '装飾品・アクセサリー',
  processingTypes: '加工種類',
  bendingProcess: '曲げ加工',
  bendingProcessDesc: '直線材を任意の角度に曲げる加工',
  coilingProcess: '巻き加工',
  coilingProcessDesc: '螺旋状やコイル状に巻く加工',
  cuttingProcess: '切断加工',
  cuttingProcessDesc: '指定寸法での精密切断',
  formingProcess: '成型加工',
  formingProcessDesc: '複合的な3次元形状の成型',
  supportedMaterials: '対応材料',
  highCarbonWire: 'ピアノ線（高炭素鋼線）',
  stainlessVariety: 'ステンレス鋼線各種',
  copperWire: '銅線・真鍮線',
  titaniumWire: 'チタン線',
  platedWire: '各種メッキ線',
  materialShape: '材料形状：丸線、平線',
  processingLength: '加工長',
  accuracy: '精度',
  minBendRadius: '最小曲げ半径：線径の1.5倍',
  applicationFields: '適用分野',
  electronicPrecision: '電子・精密機器',
  connectionTerminals: '接続端子・コネクタ',
  sensorParts: 'センサー部品',
  boardFixing: '基板固定部品',
  switchMechanism: 'スイッチ機構',
  medicalDevices: '医療機器',
  catheterParts: 'カテーテル部品',
  endoscopeParts: '内視鏡用部品',
  surgicalInstruments: '外科器具',
  inspectionParts: '検査機器部品',
  autoIndustrial: '自動車・産業機器',
  electricalParts: '電装部品',
  fixingClips: '固定クリップ',
  mechanismParts: '機構部品',
  dimensionInspection: '寸法検査',
  dimensionInspectionDesc: '3次元測定機による精密寸法検査',
  appearanceInspection: '外観検査',
  appearanceInspectionDesc: '表面品質・形状精度の全数検査',
  functionalTest: '機能試験',
  functionalTestDesc: '実用条件での動作確認試験',
  
  // Micro Spring page
  microSpringDesc: '極小サイズのばねから医療機器専用の特殊ばねまで、高精度技術で製造しています。',
  microSpringTitle: '微細ばね',
  microSpringEn: 'MICRO SPRING',
  medicalSpringTitle: '医療用特殊ばね',
  medicalSpringEn: 'MEDICAL SPECIAL SPRING',
  microFeature1: '線径0.02mm〜の極細線材を使用',
  microFeature2: '外径1mm以下の超小型ばね',
  microFeature3: '精密電子機器に最適',
  microFeature4: '高精度な寸法管理',
  microApp1: '時計内部機構',
  microApp2: '精密測定器',
  microApp3: 'カメラ機構部品',
  microApp4: 'マイクロスイッチ',
  medicalFeature1: '生体適合材料を使用',
  medicalFeature2: '高い安全性と信頼性',
  medicalFeature3: 'カスタム設計対応',
  medicalFeature4: '厳格な品質管理',
  medicalApp1: 'カテーテル部品',
  medicalApp2: '内視鏡機器',
  medicalApp3: '外科用器具',
  medicalApp4: '生体センサー',
  microSpringSpecs: '微細ばね仕様',
  medicalMaterials: '医療用材料',
  biocompatibleStainless: '生体適合性ステンレス鋼',
  titaniumAlloy: 'チタン合金：軽量・高強度材料',
  mp35n: 'MP35N：高性能合金',
  platinumWire: '白金線：高純度材料',
  manufacturingProcess: '製造プロセス',
  materialSelection: '材料選定',
  materialSelectionDesc: '用途に応じた最適材料の選定・検証',
  precisionProcessing: '精密加工',
  precisionProcessingDesc: '専用設備による高精度成型加工',
  qualityInspection: '品質検査',
  qualityInspectionDesc: '寸法・荷重・外観の全数検査',
  cleanPackaging: '清浄梱包',
  cleanPackagingDesc: 'クリーンルーム環境での最終梱包',
  electronicDevices: '電子機器',
  electronicDevicesDesc: 'スマートフォン、タブレット、ウェアラブル機器の内部部品',
  medicalEquipmentDesc: 'カテーテル、内視鏡、外科器具、検査機器',
  precisionInstruments: '精密機器',
  precisionInstrumentsDesc: '時計、測定器、光学機器の精密部品',
  opticalEquipment: '光学機器',
  opticalEquipmentDesc: 'カメラ、顕微鏡、レンズ駆動機構',
  automationEquipment: '自動化機器',
  automationEquipmentDesc: 'ロボット、精密アクチュエータ',
  analyticalInstruments: '分析機器',
  analyticalInstrumentsDesc: '分析装置、検査装置の微細部品',
  certifications: '品質保証・認証',
  isoCertification: 'ISO認証',
  isoCertificationDesc: '国際品質管理基準に準拠',
  precisionInspectionTitle: '精密検査',
  precisionInspectionDesc: '最新測定機器による全数検査',
  traceability: 'トレーサビリティ',
  traceabilityDesc: '製造履歴の完全管理',
  medicalCertification: '医療認証',
  medicalCertificationDesc: '医療機器向け材料認証',
  
  // Other Products page
  otherProductsDesc: '工業製品以外にも、日常生活で使用される様々な製品のばね部品を製造しています。',
  jewelryAccessories: '宝飾品・アクセサリー',
  earringClasp: 'ピアス・イヤリングの留め具',
  necklaceClasp: 'ネックレスのクラスプ',
  broochClasp: 'ブローチの留め金',
  watchBandParts: '時計バンドの部品',
  stationery: '文房具',
  penMechanism: 'ボールペンの内部機構',
  clipsBindings: 'クリップ・バインダー',
  mechanicalPencil: 'シャープペンシルの部品',
  staplerParts: 'ステープラーの機構部品',
  toysHobbies: '玩具・ホビー',
  toyMechanism: '玩具の駆動機構',
  modelParts: '模型の可動部品',
  fishingReelParts: '釣り具のリール部品',
  lureFrame: '疑似餌のフレーム',
  furnitureInterior: '家具・インテリア',
  chairCushion: '椅子の座面クッション',
  sofaStructure: 'ソファの内部構造',
  drawerMechanism: '引き出しの開閉機構',
  doorCloser: 'ドアクローザー',
  audioEquipment: '音響機器',
  recordNeedleArm: 'レコード針のアーム支え',
  speakerDiaphragm: 'スピーカーの振動板',
  instrumentParts: '楽器の部品',
  headphoneAdjustment: 'ヘッドホンの調整機構',
  securityLocks: '錠前・セキュリティ',
  lockMechanism: '鍵の内部機構',
  padlockParts: '南京錠の部品',
  doorLock: 'ドアロックの機構',
  securityDevice: 'セキュリティ装置',
  manufacturingFeatures: '製造の特徴',
  customDesign: 'カスタム設計',
  customDesignDesc: 'お客様の用途に合わせた完全カスタム設計に対応。デザイン性と機能性を両立した製品を提供します。',
  diverseFinishes: '多様な仕上げ',
  diverseFinishesDesc: 'メッキ加工、塗装、研磨など、様々な表面処理に対応。美しい外観と耐久性を実現します。',
  smallLotSupport: '小ロット対応',
  smallLotSupportDesc: '試作品から小ロット生産まで柔軟に対応。個人のお客様からのご注文も承ります。',
  shortDelivery: '短納期',
  shortDeliveryDesc: '豊富な経験と効率的な生産体制により、短納期でのお届けが可能です。',
  usedMaterials: '使用材料',
  metalMaterials: '金属材料',
  brassWire: '真鍮線',
  surfaceTreatment: '表面処理',
  goldPlating: '金メッキ',
  silverPlating: '銀メッキ',
  nickelPlating: 'ニッケルメッキ',
  chromePlating: 'クロムメッキ',
  variousPainting: '各種塗装',
  specialMaterials: '特殊材料',
  colorWire: 'カラーワイヤー',
  otherConsultation: 'その他応相談',
  qualityService: '品質とサービス',
  designConsultation: '設計相談',
  designConsultationDesc: '専門スタッフが設計段階からサポート',
  prototypeSupport: '試作対応',
  prototypeSupportDesc: '1個から試作品を製作可能',
  qualityGuarantee: '品質保証',
  qualityGuaranteeDesc: '全数検査による品質保証',
  rapidDelivery: '迅速配送',
  rapidDeliveryDesc: '短納期での製造・配送',
  contactMessage: 'お気軽にお問い合わせください',
  contactSubMessage: 'どんな小さなご相談でも承ります',
  
  // Contact page
  'contact.title': 'お問い合わせ',
  'contact.subtitle': 'ばねのことなら何でもご相談ください',
  'contact.intro1': '全て受注生産となっており、試作から量産まで対応いたします。',
  'contact.intro2': '図面、現物がありましたら、その旨お知らせください。',
  'contact.requiredNote': '※ のついた項目は全てご入力ください。',
  'contact.formTitle': 'お問い合わせフォーム',
  'contact.companyName': '社名',
  'contact.department': '部署名',
  'contact.fullName': 'お名前',
  'contact.address': '住所',
  'contact.telephone': '電話番号',
  'contact.email': 'メールアドレス',
  'contact.specification': '仕様',
  'contact.preferredDeliveryDate': 'ご希望の納期',
  'contact.preferredUnitPrice': 'ご希望の単価',
  'contact.characters': '文字',
  'contact.submit': '送信',
  'contact.submitting': '送信中...',
  'contact.submitSuccess': 'お問い合わせを受け付けました。ありがとうございます。',
  'contact.submitError': '送信に失敗しました。もう一度お試しください。',
  'contact.requiredFields': '必須項目を入力してください。',
  'contact.specificationLimit': '仕様は500文字以内で入力してください。',
  'contact.urgentContact': 'お急ぎの場合は',
  'contact.urgentContactDesc': '電話、Faxでも受け付けております。',
  'contact.phone': '電話番号',
  'contact.fax': 'FAX番号',
  
  // Recruit page
  'recruit.title': '求人情報',
  'recruit.subtitle': '弾力を持ち柔軟な発想ができる人を求めています',
  'recruit.intro': '弾力を持ち柔軟な発想ができるスプリングのような人を求めています。Uターン就職希望者も相談に応じます。',
  'recruit.jobListings': '募集要項',
  'recruit.tokyoOffice': '東京本社工場',
  'recruit.ogawaraFactory': '大河原工場',
  'recruit.akitaFactory': '秋田太田町工場',
  'recruit.location': '勤務地',
  'recruit.positions': '採用人員',
  'recruit.salary': '初任給',
  'recruit.person': '名',
  'recruit.yen': '円',
  'recruit.university': '大学卒',
  'recruit.technical': '高専、専門学校卒',
  'recruit.highSchool': '高校卒',
  'recruit.graduate': '大学院卒',
  'recruit.tokyoAddress': '東京都大田区大森南5丁目3番18号',
  'recruit.ogawaraAddress': '宮城県柴田郡大河原町字甲子町1-1',
  'recruit.akitaAddress': '秋田県大仙市太田町斉内字北開182-4',
  'recruit.commonInfo': '共通',
  'recruit.salaryIncrease': '昇給',
  'recruit.salaryIncreaseDetail': '年一回（4月）',
  'recruit.bonus': '賞与',
  'recruit.bonusDetail': '年二回（7月、12月）：業績による',
  'recruit.workingHours': '勤務時間',
  'recruit.workingHoursDetail': '8:30〜17:30（70分間休憩含む）勤務地、部署により異なる場合があり',
  'recruit.holidays': '休日',
  'recruit.holidaysDetail1': '週休2日制',
  'recruit.holidaysDetail2': '年間休日数 113日（会社カレンダーによる）',
  'recruit.vacation': '休暇',
  'recruit.vacationDetail1': '年次有給休暇（法定通り）',
  'recruit.vacationDetail2': '特別休暇（結婚、忌引、赴任、出産など）',
  'recruit.jobType': '職種',
  'recruit.jobTypeDetail': '生産技術、開発、生産管理（資材購買、外注管理、品質/工程管理など）、事務（営業、総務）',
  'recruit.benefits': '福利厚生、等',
  'recruit.benefitsDetail': '各種社会保険完備、退職金制度、企業年金制度、資格取得支援制度、資格取得時報奨金制度、簡易保険（日本郵便）、育児休職制度、誕生日プレゼントほか',
  'recruit.companyVideo': '会社紹介動画',
  'recruit.videoNotSupported': 'お使いのブラウザは動画タグをサポートしていません。',
  'recruit.applicationForm': '応募フォーム',
  'recruit.fullName': 'お名前',
  'recruit.email': 'メールアドレス',
  'recruit.telephone': '電話番号',
  'recruit.address': '住所',
  'recruit.education': '最終学歴',
  'recruit.selectEducation': '選択してください',
  'recruit.desiredPosition': '希望職種',
  'recruit.desiredLocation': '希望勤務地',
  'recruit.selectLocation': '選択してください',
  'recruit.message': '自己PR・志望動機',
  'recruit.characters': '文字',
  'recruit.submit': '応募する',
  'recruit.submitting': '送信中...',
  'recruit.submitSuccess': 'ご応募ありがとうございます。担当者より折り返しご連絡いたします。',
  'recruit.submitError': '送信に失敗しました。もう一度お試しください。',
  'recruit.requiredFields': '必須項目を入力してください。',
  'recruit.messageLimit': 'メッセージは500文字以内で入力してください。',
  'recruit.contactInfo': 'お問い合わせ先',
  'recruit.contactAddress': '〒143-0013 東京都大森南5丁目3番18号',
  'recruit.contactDepartment': '東京本社 総務部',
  'recruit.contactTel': 'Tel: 03-3743-0231（代）',
  'recruit.contactFax': 'Fax: 03-3743-0235',
  
  // Company Overview page
  'overview.subtitle': '超精密スプリングの専門メーカ',
  'overview.companyName': '商号',
  'overview.companyNameValue': '小松ばね工業株式会社',
  'overview.foundingDate': '創業年月日',
  'overview.foundingDateValue': '1941年(昭和16年)5月23日',
  'overview.established': '会社設立',
  'overview.establishedValue': '1952年(昭和27年)12月1日',
  'overview.capital': '資本',
  'overview.capitalValue': '払込資本金 1億円',
  'overview.headquarters': '本社',
  'overview.headquartersValue': '東京都大田区大森南5丁目3番18号',
  'overview.president': '代表取締役社長',
  'overview.presidentValue': '小松 万希子',
  'overview.products': '製造品目',
  'overview.productsValue': 'あらゆる分野で使用される精密線ばね:コイルばね(圧縮、引張)、トーションばね、ワイヤフォーミング加工',
  'overview.equipmentSubtitle': '少量から1000万個単位の注文に対応',
  'overview.springMachine': 'スプリング自動成型機',
  'overview.springMachineValue': '475台',
  'overview.heatTreatment': '熱処理炉及び洗浄機',
  'overview.heatTreatmentValue': '33台',
  'overview.grindingMachine': 'ばね端面研磨機',
  'overview.grindingMachineValue': '15台',
  'overview.inspectionEquipment': '検査器具',
  'overview.inspectionEquipmentValue': '60台',
  'overview.machineTools': '工作機械',
  'overview.machineToolsValue': '15台',
  
  // Company Message page
  'message.title': '代表者メッセージ',
  'message.subtitle': 'お客様に必要とされる企業を目指して',
  'message.greeting': 'ホームページをご覧いただき、ありがとうございます。',
  'message.content1': '小松ばね工業株式会社は、1941年に創業し、1952年に会社を設立いたしました。精密ばねの専門メーカーとして、80年以上の歴史を持っております。',
  'message.content2': '当社の企業理念は「お客様に必要とされる」ことです。そのために、「お客様第一主義に徹する」ことを一貫して追求し、高品質なばねづくりに取り組んでまいりました。',
  'message.content3': 'ばねは小さな部品ですが、様々な製品の中で重要な役割を果たしています。産業機器から医療機器、電子機器、日用品まで、幅広い分野で当社のばねが使用されています。',
  'message.content4': '1個の試作品から量産まで、お客様のニーズに柔軟に対応させていただいております。また、安定した品質と納期を守る体制も整えております。',
  'message.content5': '今後も技術の向上に努め、お客様にご満足いただける製品を提供してまいります。引き続きご愛顧のほど、よろしくお願い申し上げます。',
  'message.president': '代表取締役社長',
  'message.presidentName': '小松 万希子',
  
  // Company Office page
  'office.title': '事業所',
  'office.subtitle': '全国の生産・販売ネットワーク',
  'office.tokyoTitle': '東京本社工場',
  'office.tokyoAddress': '〒143-0013 東京都大田区大森南5丁目3番18号',
  'office.tokyoTel': 'Tel: 03-3743-0231（代表）',
  'office.tokyoFax': 'Fax: 03-3743-0235',
  'office.tokyoAccess': 'アクセス',
  'office.tokyoAccessDetail': 'JR大森駅より徒歩15分 / 京急立会川駅より徒歩10分',
  'office.ogawaraTitle': '大河原工場',
  'office.ogawaraAddress': '〒989-1246 宮城県柴田郡大河原町字甲子町1-1',
  'office.ogawaraTel': 'Tel: 0224-53-2336',
  'office.ogawaraFax': 'Fax: 0224-53-2337',
  'office.ogawaraAccessDetail': 'JR大河原駅より車で5分',
  'office.akitaTitle': '秋田太田町工場',
  'office.akitaAddress': '〒019-1601 秋田県大仙市太田町斉内字北開182-4',
  'office.akitaTel': 'Tel: 0187-88-1333',
  'office.akitaFax': 'Fax: 0187-88-1334',
  'office.akitaAccessDetail': 'JR上境駅より車で10分',
  
  // Company History page
  'history.title': '会社沿革',
  'history.subtitle': '80年以上の歴史と伝統',
  'history.1941': '1941年5月：東京都大田区大森に小松ばね製作所を創業',
  'history.1952': '1952年12月：小松ばね工業株式会社を設立',
  'history.1965': '1965年4月：宮城県に大河原工場を設立',
  'history.1985': '1985年3月：秋田太田町工場を設立',
  'history.2002': '2002年2月：ISO 9001:2000認証取得',
  'history.2007': '2007年1月：エコアクション21認証取得',
  'history.2015': 'ISO 9001:2015へ移行',
  'history.present': '現在：全国3工場で精密ばねを製造',
  
  // Company CSR page
  'csr.title': '品質方針/環境方針',
  'csr.subtitle': '品質と環境への取り組み',
  'csr.qualityPolicyTitle': '品質方針',
  'csr.isoRegistration': '登録日:2002年2月1日',
  'csr.isoNumber': '登録証番号:JQA-QM7736',
  'csr.qualityContent1': '小松ばね工業株式会社が実施する「ばね」の製造活動において、「お客様に必要とされる」を経営理念とし、「お客様第一主義に徹する」と言う基本方針のもと、企業発展の原理「成長と拡大」「安定」を同時に遂行することを継続する。',
  'csr.qualityContent2': '今後の課題は精密機器産業の急速な進化と共に超精密ばねのモノづくり企業としての技術の向上と柔軟な発想力で、品質の均一化、納期の厳守、コストへの適正化を図り、企業存続の必要利益の確保を遵守する。',
  'csr.qualityContent3': 'お客様の要求事項への適合及び品質マネジメントシステムの有効性を継続的に改善促進する誓約を含め品質方針を定める。',
  'csr.qualityStatement': '「お客様の要望を満たすことを我社の事業とし、信頼という製品を提供し続けること」',
  'csr.qualityContent4': 'この品質方針は我社の事業の本質であり、全社員がこの方針を理解し、意図する製品、及びサービスを確実に提供できるようにすることが基本である。各人は決められたことを確実に実施し活動に責任を持つことで、意図した成果を達成できる。',
  'csr.qualitySignature': '小松ばね工業株式会社 代表取締役社長 小松万希子',
  'csr.environmentalPolicyTitle': '環境経営方針',
  'csr.ecoRegistration': '認証・登録日:2007年1月18日',
  'csr.ecoNumber': '認証番号:0001270',
  'csr.philosophy': '1. 企業理念',
  'csr.philosophyStatement': '「お客様に必要とされる」',
  'csr.philosophyContent': '我々が永遠であるためには、お客様に強く必要とされなければならない。いかなる環境でも、より優れた技術でより優れた「ばね」をつくることで、我々は企業を通じて社会に貢献する。エコアクション21の理念を基に「地球との共生」を考え、当社の全ての業務にかかわる環境影響を明確にし、環境に優しい企業活動を目指す。',
  'csr.policy2': '2. 環境経営を通じてより良い進化した組織へ成長するために、今後の経営における課題(組織の外部、内部)とチャンスを整理し、課題を克服する事で、事業発展の機会になる。事業内容、事業を取り巻く状況、事業と環境のかかわりによって変化する課題とチャンスを必要に応じて見直しをする。',
  'csr.policy3': '3. 企業理念、事業活動における環境への負荷を整合させ、取り組むべき重点分野を特定する。',
  'csr.policy3Item1': '1) 電力、ガス、ガソリンの削減による、CO₂の排出抑制',
  'csr.policy3Item2': '2) 廃棄物の分別・リサイクル、紙の削減による、廃棄物の排出抑制',
  'csr.policy3Item3': '3) 節水などによる、使用量の削減',
  'csr.policy3Item4': '4) 化学物質使用量の削減',
  'csr.policy3Item5': '5) 原材料の効率的な使用による、製造廃棄物の削減',
  'csr.policy3Item6': '6) グリーン調達の推進',
  'csr.policy3Item7': '7) 製品含有化学物質を把握し、含有、使用の禁止',
  'csr.policy4': '4. 環境経営の活動を通じて環境目標、環境計画の継続的改善に努め、環境経営のステップアップを図る。',
  'csr.policy5': '5. 環境関連法規の遵守を誓約する。',
  'csr.policy6': '6. 全従業員へ環境経営方針の内容を理解し、取り組むことが出来るよう掲示や会議、朝礼などを活用して周知する。',
  'csr.co2Title': 'CO₂削減への取り組み',
  'csr.co2Intro': '小松ばね工業株式会社は、持続可能な社会の実現に向けて、CO₂排出削減に積極的に取り組んでいます。環境への配慮は企業の責任であると考え、以下のような具体的な対策を進めています。',
  'csr.currentInitiatives': '現在の取り組み',
  'csr.initiative1Title': '・大河原工場の電力を100%再生可能エネルギーへ切り替え',
  'csr.initiative1Detail': '再エネ由来の電力を使用することで、工場の運用に伴うCO₂排出を大幅に削減しています。',
  'csr.initiative2Title': '・全社LED照明化',
  'csr.initiative2Detail': '従来照明に比べ消費電力の少ないLEDを導入し、省エネ化を実現。',
  'csr.initiative3Title': '・電気自動車の導入(1台)',
  'csr.initiative3Detail': '社用車の一部をEV化し、移動に伴う環境負荷を軽減。',
  'csr.initiative4Title': '・「HTT取組宣言企業(東京都)」としての活動',
  'csr.initiative4Detail': '省エネ・創エネ・蓄エネを推進する姿勢を都に公表し、取り組みを強化。',
  'csr.initiative5Title': '・「おおたクールアクション(大田区)」参加',
  'csr.initiative5Detail': '地域の環境活動へ参加し、地元とともに持続可能なまちづくりを目指しています。',
  'csr.futureInitiatives': '今後の予定',
  'csr.future1Title': '・全社的に再エネ電力プランへの移行を推進',
  'csr.future1Detail': '工場だけでなく、各事業所やオフィスも再生可能エネルギーに切り替えていきます。',
  'csr.future2Title': '・本社空調設備の省エネ型への更新',
  'csr.future2Detail': '古い空調機器を高効率の省エネタイプに交換し、使用電力の削減を図ります。',
  'csr.conclusion': 'こうした活動を通じて、小松ばね工業株式会社は環境への負荷を最小限に抑えながら、持続可能な未来の実現に貢献してまいります。',
};
